// Module
var code = "<div ng-controller=\"BillPayController\" class=\"panel full-height ir-dashboard-view\"> <iframe name=\"billPayIframe\" id=\"billPayIframe\" frameborder=\"0\" src=\"\" width=\"100%\" height=\"100%\" title=\"Bill Pay\"></iframe> </div> ";
// Exports
module.exports = code;